import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { configuration } from 'src/configuration';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';

@Component({
  selector: 'app-signup-modal',
  templateUrl: './signup-modal.component.html',
  styleUrls: ['./signup-modal.component.css']
})
export class SignupModalComponent {
  @Output() closeModalBody: EventEmitter<void> = new EventEmitter<void>();

  submit = false;
  isSubmitted = false;
  // signupForm: FormGroup;
  myFormSubmit : boolean = false;
  emirates = configuration.EMIRATES;
  is_show_otp: any = false;
  errorMessage: any = '';
  otpErrorMessage: any = '';
  myOtpFormSubmit = false;
  countries = configuration.countries;
  isCountryDropdownDisabled : any = true

  

  otpForm : any = new FormGroup({
    otp_phone: new FormControl('',Validators.required),
    otp_email: new FormControl('',Validators.required)
  });

  signupForm : any = new FormGroup({
    f_name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      p_num: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      emirates: new FormControl('',Validators.required)
  });

  constructor(private formBuilder: FormBuilder, public shared: SharedService, private router: Router, public apiServices: ApiServiceService) {
    // this.signupForm = this.formBuilder.group({
    //   f_name: new FormControl('', Validators.required),
    //   email: new FormControl('', Validators.required),
    //   p_num: new FormControl('', Validators.required),
    //   country: new FormControl('', Validators.required),
    //   emirates: new FormControl('',Validators.required)
    // });
    this.shared.isWhiteMenu = false;
  }

  ngOnInit(): void {
    this.signupForm.patchValue({
      country : 'UAE'
    })
    this.signupForm.get('country')?.disable();
  }

  get formControls() {
    return this.signupForm.controls;
  }

  get otpFormControls() {
    return this.otpForm.controls;
  }

  async onSubmit() {
    let country_name;
    this.myFormSubmit = true;
    // console.log("this.signupForm.valid",this.signupForm.valid)
    if (this.signupForm.valid) {
      if(this.signupForm.value.country){
        let data = configuration.countries.filter(obj => obj.code == this.signupForm.value.country);
        country_name = data[0].name;
      }
  
      let res = await this.apiServices.POST_apiRequest(configuration.ENDPOINT.SELLER_REGISTRATION_CHECK, {
        "name": this.signupForm.value.f_name,
        "email": this.signupForm.value.email,
        "phone": this.signupForm.value.p_num,
        "city_id": this.signupForm.value.emirates,
        "country" : this.signupForm.value.country,
        "country_name" : country_name
      });
  
      if (res && !res.error) {
        this.isSubmitted = true;
        this.is_show_otp = true;
      } else {
        console.error("Error submitting the form:", res);
        this.errorMessage = res.message;
      }
    }
  }
  
  
  closeBody() {
    this.closeModalBody.emit();
  }

  async onSignUp() {
    console.log("this.otpForm",this.otpForm)
    this.myOtpFormSubmit = true
    if (this.otpForm.valid) {
      let res = await this.apiServices.POST_apiRequest(configuration.ENDPOINT.SELLER_OTP_VERIFICATION, {
        "email": this.signupForm.value.email,
        "phone": this.signupForm.value.p_num,
        "otp_email": this.otpForm.value.otp_email,
        "otp_phone": this.otpForm.value.otp_phone
      });
      if (res && !res.error && res.data) {
        let res = await this.apiServices.POST_apiRequest(configuration.ENDPOINT.SELLER_REGISTRATION, {
          "name": this.signupForm.value.f_name,
          "email": this.signupForm.value.email,
          "phone": this.signupForm.value.p_num,
          "country": this.signupForm.value.country,
          "city_id": this.signupForm.value.emirates,
        });

        if (res && !res.error) {
          this.myOtpFormSubmit = false
          localStorage.setItem(configuration.LOCAL_STORAGE.USER_TOKEN, res.data.token);
          localStorage.setItem(configuration.LOCAL_STORAGE.USER_ID, res.data.seller.id);
          localStorage.setItem(configuration.LOCAL_STORAGE.USER_NAME, res.data.seller.name);
          localStorage.setItem(configuration.LOCAL_STORAGE.USER_EMAIL, res.data.seller.email);
          localStorage.setItem(configuration.LOCAL_STORAGE.USER_PHONE, res.data.seller.phone);
          window.location.href = '/set-password'
        } else {
          console.error("Error submitting the form:", res);
          this.errorMessage = res.message
        }
      } else {
        this.otpErrorMessage = res.message
      }
    }
  }

  goBack() {
    this.is_show_otp = false;
    this.isSubmitted = false;
  }
}
